import { ENDPOINT } from "services/axios/constants/endpoints";
import { HTTPMethods } from "services/axios/types/http";
import { getDataFromRequest } from "services/axios/utility/helper";
import { AppThunk } from "services/redux/rootReducer";

const getWorkflowRuns = (): AppThunk<Promise<any>> => async () => {
    return await getDataFromRequest(
        ENDPOINT.GITHUB_API.LIST_WORKFLOW_RUNS,
        HTTPMethods.GET,
        process.env.REACT_APP_GITHUB_TOKEN,
        {},
        {
            headers: {
                "Content-Type": "application/vnd.github+json",
            },
        },
        false,
        true
    );
};

export default getWorkflowRuns;
